import type { SVGProps } from 'react'

export const ContentCutFilledIcon = ({ ...props }: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="currentColor"
      {...props}
    >
      <path d="M481.54-415.39 372.15-306q8.39 15 11.96 31.81 3.58 16.81 3.58 34.19 0 60.29-42.92 103.22T241.58-93.85q-60.27 0-103.23-42.92T95.39-239.96q0-60.27 42.93-103.23t103.22-42.96q17.38 0 34.19 3.57 16.81 3.58 31.81 11.97L416.92-480 307.54-589.39q-15 8.39-31.81 11.97-16.81 3.57-34.19 3.57-60.29 0-103.22-42.92T95.39-719.96q0-60.27 42.92-103.23t103.19-42.96q60.27 0 103.23 42.93T387.69-720q0 17.38-3.58 34.19Q380.54-669 372.15-654l447.23 447.23q22 22 9.85 49.77-12.15 27.77-42.93 27.77-8.91 0-17.33-3.59-8.41-3.58-14.82-9.95L481.54-415.39Zm110.77-110.76-64.62-64.62 226.46-226.46q6.47-6.37 14.95-9.95 8.48-3.59 17.36-3.59 30.69 0 42.5 28.08 11.81 28.07-10.19 50.07L592.31-526.15Zm-350.77-107.7q35.54 0 60.85-25.3 25.3-25.31 25.3-60.85 0-35.54-25.3-60.85-25.31-25.3-60.85-25.3-35.54 0-60.85 25.3-25.31 25.31-25.31 60.85 0 35.54 25.31 60.85 25.31 25.3 60.85 25.3Zm240 163.85q4 0 7-3t3-7q0-4-3-7t-7-3q-4 0-7 3t-3 7q0 4 3 7t7 3Zm-240 316.15q35.54 0 60.85-25.3 25.3-25.31 25.3-60.85 0-35.54-25.3-60.85-25.31-25.3-60.85-25.3-35.54 0-60.85 25.3-25.31 25.31-25.31 60.85 0 35.54 25.31 60.85 25.31 25.3 60.85 25.3Z" />
    </svg>
  )
}
